// src/index.js (CRA)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// CSRF shim import comes with the other imports…
import { installCsrfFetch } from './utils/csrfFetch';

// …then call it once before rendering React.
installCsrfFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
